// API configuration for different environments
const config = {
  development: {
    // Use empty string for development to rely on React dev server proxy
    apiUrl: ''
  },
  staging: {
    apiUrl: process.env.REACT_APP_API_URL || 'https://condor-staging.up.railway.app'
  },
  production: {
    apiUrl: process.env.REACT_APP_API_URL || 'https://condor-production.up.railway.app'
  }
};

// Use custom environment variable for staging to avoid Vercel NODE_ENV override
const environment = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'development';


export const API_BASE_URL = config[environment].apiUrl;
export const API_URL = `${API_BASE_URL}/api`;

// Default timeout for API requests
export const API_TIMEOUT = 30000;

// Axios default configuration will be handled by setupProxy.js in development
// In production, requests will go directly to the API_URL